import gql from 'graphql-tag'
import client from '@stores/apollo'
import handleFetchResult from '@utils/handleFetchResult'

interface CSVVariables {
  orderBy: string
  where: any
}

interface IPayload {
  createTicketExport: { export: { url: string } }
}

const mutateHandler = handleFetchResult<IPayload, string>({
  handler: (data) => data.createTicketExport.export.url,
  name: 'CSV',
})

const mutation = gql`
  mutation CreateTicketExport($input: CreateTicketExportInput!) {
    createTicketExport(input: $input) {
      export {
        url
        name
      }
    }
  }
`
export default function csv({ orderBy, where }: CSVVariables): Promise<string> {
  return client.gql
    .mutate({ mutation, variables: { input: { orderBy, where } } })
    .then(mutateHandler)
}
